import Auth from './auth'
import ChangeLog from './changelog'
import Download from './download'
import terms from './terms'

export default [
    ...ChangeLog,
    ...Auth,
    ...terms,
    ...Download,
]
